import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import ApiConfig from "../../../api/ApiConfig";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import { notifyError, notifySuccess } from "../../../toaster/notify";

// Step 11 / Pass A: this hook owns every useState, useRef, useEffect,
// socket subscription, and API call that previously lived in ChatBox.js.
// JSX consumes the returned object; behavior must match pre-extraction.
export const useChatBox = ({ setSelectedList, updatePinUnpinChat } = {}) => {
  const [members, setMembers] = useState(false);
  const [addMembers, setAddMembers] = useState(false);
  const [addSubMembers, setAddSubMembers] = useState(false);

  const [newMessage, setNewMessage] = useState("");
  const [files, setFiles] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [SubchianlMemberList, setSubchianlMemberList] = useState([]);
  console.log("SubchianlMemberList", SubchianlMemberList);

  const fileUpload = useRef(null);
  const [message, setmessage] = useState("");
  const toast = useRef(null);
  const lastMsg = useRef(null);
  const firstMsg = useRef(null);
  const pindropdown = useRef(null);
  const msgRef = useRef([]);
  const [membersAdded, setMembersAdded] = useState([]);
  console.log("membersAdded", membersAdded);

  const [menstionedUsers, setMenstionedUsers] = useState([]);
  console.log("menstionedUsers", menstionedUsers);

  const [selectedReaction, setselectedReaction] = useState(null);
  const [showAudioErr, setShowAudioErr] = useState(false);
  const [audioPreview, setAudioPreview] = useState(false);

  const [closeOutsideClick, setCloseOutSideClic] = useState(true);

  const handleReactionShow = (message_id) => {
    setselectedReaction(message_id);
  };
  const [emogi, setEmogi] = useState(false);

  const {
    sendMessage,
    activeChat,
    userData,
    socket,
    currentSChannel,
    setActiveChat,
    teamMembers,
    page,
    conversations,
    newMessages,
    userTyping,
    editMsg,
    setEditMsg,
    setNewMessages,
    replyTo,
    setReplyTo,
    noMorePages,
    paginationLoader,
    setPage,
    loading,
    suggetions,
    membersArray,
    setUserTyping,
    setLoading,
    setPaginationLoader,
    setConversations,
    setNoMorePages,
    setRecentChats,
    recentChats,
    pinnedChats,
    setPinnedChats,
    projects,
    setProjects,
    teams,
    setTeams,
    projectIdTast,
    permissions,
    SubChannelId,
    setmsgdelete, selectedDomainId
  } = useContext(AppContext);

  useEffect(() => {
    setmessage("");
  }, [currentSChannel])

  const [openVoiceReq, setOpenVoiceReq] = useState(false);
  const [ChatBotAiData, setChatBotAiData] = useState({});
  console.log("ChatBotAiData", ChatBotAiData);


  useEffect(() => {
    // if (page > 0) {
    //   firstMsg && firstMsg.current && firstMsg.current.scrollIntoView();
    // } else lastMsg && lastMsg.current && lastMsg.current.scrollIntoView();
  }, [newMessages, lastMsg, conversations, userTyping]);
  useEffect(() => {
    lastMsg && lastMsg.current && lastMsg.current.scrollIntoView();
  }, [newMessages]);

  useEffect(() => {
    lastMsg && lastMsg.current && lastMsg.current.scrollIntoView();
  }, []);

  // Capture the unread count at the moment a channel becomes active.
  // `activeChat.unread_count` is set from the sidebar tile click; downstream
  // effects zero out the count in the chat lists, but `activeChat` itself
  // retains the value. The scroll effect below uses this snapshot to decide
  // whether to anchor on the first unread message vs. the bottom.
  const initialUnreadRef = useRef(0);
  useEffect(() => {
    initialUnreadRef.current = Number(activeChat?.unread_count) || 0;
  }, [currentSChannel]);

  // When opening a chat (currentSChannel changes) and the first page of
  // history finishes loading, position the view:
  //   - If the chat has unread messages, anchor on the FIRST unread message
  //     so the user sees the top of the unread block and can read down
  //     through it (WhatsApp/Slack pattern). Without this, a 7+ message
  //     burst from the other side would dump the user straight at the most
  //     recent message and they'd have to scroll up to find what they
  //     missed.
  //   - Otherwise jump to the latest message (no manual scrolling on chat
  //     switch).
  // Guarded by `page === 0` so pagination (which prepends older messages)
  // doesn't yank the view.
  //
  // Scroll strategy: set `scrollTop = scrollHeight` on the scrollable
  // ancestor directly for the bottom case — `scrollIntoView()` on the
  // zero-height sentinel was unreliable when attachments were still
  // loading. The 250ms follow-up pass catches images/videos that finish
  // loading after the first paint.
  useEffect(() => {
    if (page !== 0) return;
    if (!conversations || !conversations.length) return;

    const performScroll = () => {
      const node = lastMsg && lastMsg.current;
      if (!node) return;
      let parent = node.parentElement;
      while (parent && parent.scrollHeight <= parent.clientHeight) {
        parent = parent.parentElement;
      }

      const unread = initialUnreadRef.current;
      if (unread > 0) {
        // conversations are oldest-first; the last `unread` items are the
        // unread block. Clamp at 0 in case the unread count exceeds the
        // loaded page (then we anchor at the oldest loaded message).
        const targetIdx = Math.max(0, conversations.length - unread);
        const target = msgRef.current && msgRef.current[targetIdx];
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ block: "start" });
          return;
        }
      }

      if (parent) {
        parent.scrollTop = parent.scrollHeight;
      } else if (node.scrollIntoView) {
        node.scrollIntoView({ block: "end" });
      }
    };

    const rafId = requestAnimationFrame(performScroll);
    const timeoutId = setTimeout(() => {
      performScroll();
      // Clear the unread-anchor intent after positioning for this open so
      // any later re-render (reactions, edits) doesn't snap the view back.
      initialUnreadRef.current = 0;
    }, 250);
    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [currentSChannel, conversations.length, page]);

  useEffect(() => {
    setFiles(false);
  }, [currentSChannel]);

  const save = () => {
    socket &&
      socket.emit("add-members", {
        schannel_id: SubChannelId,
        members: membersAdded.map((mem) => mem.id),
      });

    notifySuccess("members Aded");

  };
  function onSelect(selectedList, selectedItem) {
    setSelectedList(selectedList);
  }
  function onRemove(selectedList, removedItem) {
    setSelectedList(selectedList);
  }

  const deletMessage = (id) => {
    setmsgdelete(true)
    socket.emit("is_deleted", {
      schannel_id: currentSChannel,
      message_id: id,
    });
  };

  useEffect(() => {
    if (currentSChannel) {
      socket && socket.emit("get-members", { schannel_id: currentSChannel });
    }
  }, [currentSChannel, socket]);

  const pinChat = () => {
    pindropdown.current && pindropdown.current.click();
    PostCallWithErrorResponse(
      ApiConfig.PIN_CHAT,
      JSON.stringify({ schannel_id: currentSChannel })
    ).then((res) => {
      if (res.json.status) {
        notifySuccess(res.json.message);
        setActiveChat({ ...activeChat, pin: true });
        updatePinUnpinChat();
        // getRecentChats();
      }
    });
  };
  const unpinChat = () => {
    pindropdown.current && pindropdown.current.click();
    PostCallWithErrorResponse(
      ApiConfig.UNPIN_CHAT,
      JSON.stringify({ schannel_id: currentSChannel })
    ).then((res) => {
      if (res.json.status) {
        notifySuccess(res.json.message);
        setActiveChat({ ...activeChat, pin: false });
        updatePinUnpinChat();
        // getRecentChats();
      }
    });
  };
  var parameter_Start_index =
    activeChat && activeChat?.last_seen && activeChat?.last_seen.indexOf(".");
  let user =
    activeChat &&
    activeChat?.em &&
    activeChat?.em
      .sort((a, b) =>
        (a.User_Id ? a.User_Id : a.EmployeeId) - b.User_Id
          ? b.User_Id
          : b.EmployeeId
      )
      .filter(
        (user) =>
          (user.User_Id ? user.User_Id : user.EmployeeId) != userData.EmpId
      )[0];



  useEffect(() => {
    setChatBotAiData(user)
  }, [user])

  var parameter_Start_index =
    user && user.last_seen && user.last_seen.indexOf(".");
  var last_seen =
    user &&
    user.last_seen &&
    user.last_seen.substring(0, parameter_Start_index) + ".209Z";

  const [reactions, setReactions] = useState([]);
  // GET PRIVATE CHAT LIST
  useEffect(() => {
    socket &&
      socket.on("get-conversation", (response) => {
        var data = response.result;
        var os_type = response.os_type;
        setLoading(false);
        setPaginationLoader(false);
        if (data?.length) {
          if (data[0].Team_Channel_Id == currentSChannel && os_type == "web") {
            if (data.Sender_Id !== userData.EmpId) {
              socket &&
                socket.emit("update-last-msg-read", {
                  schannel_id: data[0].Team_Channel_Id,
                  LastMsgId: data[0].Team_Message_Id,
                });
            }

            setConversations([
              ...data
                .map((msg) => {
                  let parsedReactionArr =
                    msg?.reactions && JSON?.parse(msg?.reactions);
                  return { ...msg, edit: false, reactions: parsedReactionArr };
                })
                .reverse(),
              ...conversations,
            ]);
          }

          let reactionArr = data.map(
            (ele) => ele?.reactions && JSON?.parse(ele?.reactions)
          );
        } else setNoMorePages(true);
      });

    socket &&
      socket.on("typing", (data) => {
        if (data?.userName?.includes("@")) {
          console.log(data);
          var userName = data.userName && data.userName.split("@")[0];
          userName = userName[0].toUpperCase() + userName.slice(1);
        } else {
          var userName = data.userName;
        }

        if (data.schannel_id == currentSChannel) {
          setUserTyping({
            status: true,
            userName: [data?.FirstName, data?.LastName].filter(Boolean).join(" "),
            currentSChannel: data.schannel_id,
            EmpId: data?.EmpId,
          });
        }
      });
    socket &&
      socket.on("stoptyping", (data) => {
        if (data.schannel_id == currentSChannel) {
          setUserTyping({ status: false, userName: null });
        }
      });
    setReplyTo({});
    setEditMsg({});

    socket &&
      socket.on("add-reaction", (res) => {
        let finalConversationwithemoji =
          conversations &&
          conversations.length > 1 &&
          conversations.map((chatObj) => {
            return chatObj?.Team_Message_Id == res?.message_id
              ? {
                ...chatObj,
                reactions: [
                  ...chatObj.reactions,
                  {
                    reaction_id: res?.reaction_id,
                    reaction: res?.reaction,
                    reacted_by: res?.Sender_Id,
                  },
                ],
              }
              : chatObj;
          });

        conversations.length > 0 &&
          setConversations(finalConversationwithemoji);

        let finalNewMessagewithemojis =
          newMessages &&
          newMessages.length > 0 &&
          newMessages.map((chatObj) => {
            return chatObj?.message_id == res?.message_id
              ? {
                ...chatObj,
                reactions: [
                  ...chatObj.reactions,
                  {
                    reaction_id: res?.reaction_id,
                    reaction: res?.reaction,
                    reacted_by: res?.Sender_Id,
                  },
                ],
              }
              : chatObj;
          });

        newMessages.length > 0 && setNewMessages(finalNewMessagewithemojis);
      });

    socket &&
      socket.on("remove-reaction", (res) => {
        let finalConversationwithemoji =
          conversations &&
          conversations.length > 0 &&
          conversations.map((chatObj) => {
            let filterArr =
              chatObj &&
              chatObj?.reactions &&
              chatObj?.reactions.filter(
                (ele) => ele?.reaction_id !== res?.reaction_id
              );

            return chatObj?.Team_Message_Id == res?.message_id
              ? {
                ...chatObj,
                reactions: filterArr,
              }
              : chatObj;
          });

        conversations.length > 0 &&
          setConversations(finalConversationwithemoji);

        let finalNewMessagewithemoji =
          newMessages &&
          newMessages.length > 0 &&
          newMessages.map((chatObj) => {
            let filterArr =
              chatObj &&
              chatObj?.reactions &&
              chatObj?.reactions.filter(
                (ele) => ele?.reaction_id !== res?.reaction_id
              );
            return chatObj?.message_id == res?.message_id
              ? {
                ...chatObj,
                reactions: filterArr,
              }
              : chatObj;
          });

        newMessages.length > 0 && setNewMessages(finalNewMessagewithemoji);
      });

    return () => {
      if (socket) {
        socket.off("get-conversation");
        socket.off("typing");
        socket.off("stoptyping");
        socket.off("add-reaction");
      }
    };
  }, [conversations, socket, currentSChannel, userData, newMessages]);

  const inputRef = useRef(null);
  const joinRoom = (schannel_id) => {
    socket.emit("join-room", {
      schannel_id: schannel_id,
    });
  };



  useEffect(() => {
    activeChat &&
      activeChat?.Team_Channel_Id &&
      activeChat?.Team_Channel_Id &&
      joinRoom(
        activeChat && activeChat?.Team_Channel_Id && activeChat?.Team_Channel_Id
      );
    const clearActiveChatUnread = (chat) =>
      chat &&
      chat.Team_Channel_Id == activeChat?.Team_Channel_Id &&
      activeChat?.Team_Channel_Id
        ? { ...chat, unread_count: 0 }
        : chat;

    setRecentChats((prev) =>
      Array.isArray(prev) && prev.length ? prev.map(clearActiveChatUnread) : prev
    );
    setPinnedChats((prev) =>
      Array.isArray(prev) && prev.length ? prev.map(clearActiveChatUnread) : prev
    );

    let filterProjectsWithUnreadCount =
      projects &&
      projects.length > 0 &&
      projects.filter((proj) => {
        if (
          proj?.channel_id == activeChat?.Team_Channel_Id &&
          activeChat?.Team_Channel_Id
        ) {
          proj.subchannel &&
            proj.subchannel.length > 0 &&
            proj.subchannel.filter((schannel) => {
              if (schannel?.Team_Channel_Id == activeChat?.Team_Channel_Id) {
                schannel.unread_count = 0;
              }
              return schannel;
            });
        }
        return proj;
      });

    setProjects(filterProjectsWithUnreadCount);

    let filterWithUnreadChat =
      teams &&
      teams.length > 0 &&
      teams.filter((proj) => {
        if (
          proj?.channel_id == activeChat?.Team_Channel_Id &&
          activeChat?.Team_Channel_Id
        ) {
          proj.subchannel &&
            proj.subchannel.length > 0 &&
            proj.subchannel.filter((schannel) => {
              if (schannel?.Team_Channel_Id == activeChat?.Team_Channel_Id) {
                schannel.unread_count = 0;
              }
              return schannel;
            });
        }
        return proj;
      });
    setTeams(filterWithUnreadChat);
  }, [activeChat]);

  const removeReaction = (reactionId, Team_Channel_Id, Team_Message_Id) => {
    socket &&
      socket.emit("remove-reaction", {
        reaction_id: reactionId,
        schannel_id: Team_Channel_Id,
        message_id: Team_Message_Id,
      });
  };
  const [prevDate, setPrevDate] = useState(null);

  const addCreateTask = (Message_Text, mentionId) => {
    let currentDate = new Date().toISOString().split("T")[0];

    let body = JSON.stringify({
      EmpId: Number(mentionId || userData.EmpId),
      OrgId: Number(userData.OrgId),
      TaskId: 0,
      ProjectId: Number(projectIdTast),
      TaskName: Message_Text,
      StartDate: currentDate,
      EndDate: currentDate,
      BudgetedHours: 10,
      Priorityid: 2,
      Approved: "p",
      TaskDescription: Message_Text,
      TaskSource: 'Chat Task'
    });

    PostCallWithErrorResponse(ApiConfig.CREATE_Task, body)
      .then((res) => {
        if (res?.json?.Success === true) {
          notifySuccess(res?.json?.Message);
        } else {
          notifyError(res?.json?.Message);
        }
      })
      .catch((err) => {
        console.log("error,", err);
      });
  };

  const handleCopyUrl = () => {
    simpleGetCallWithToken(ApiConfig.GITLABURL + currentSChannel)
      .then((res) => {
        // console.log("Data", res.data);
        console.log("res", res);

        if (res.success == true) {
          // notifySuccess("URL copied to clipboard!");

          // Copy to clipboard
          navigator.clipboard.writeText(res.data.webhookUrl).then(() => {
            notifySuccess("URL copied to clipboard!");
            // setComplianceList(res.Data);
          });
        }
      })
      .catch((err) => {
        console.log("err", err);

        notifyError("Failed to copy URL.");
      });
  };


  // ChatBot Apiu code




  const chatbotapicall = (msg, senderId) => {




    if (msg.includes("@")) {
      let regex = /@\[.+?\]\(.+?\)/gm;
      let displayRegex = /@\[.+?\]/g;
      let idRegex = /\(.+?\)/g;
      let matches = msg.match(regex);
      let arr = [];
      let str = "";
      matches &&
        matches.forEach((m) => {
          let display = m
            .match(displayRegex)[0]
            .replace("[", "")
            .replace("]", "");
          arr.push(display);
        });
      let newComment = msg.split(regex);

      for (let i = 0; i < newComment.length; i++) {
        const element = newComment[i];
        str += element + `${arr[i]}`.replace("undefined", "");
      }
      msg = str;
    }
    const body = JSON.stringify({
      message: msg.replaceAll("@Vehicle Ai assistant", "").trim(),
      sender: senderId,

    });
    PostCallWithErrorResponse(ApiConfig.CHATBOTAIURL, body)
      .then((res) => {

        console.log('meara naame kya hai', res);

        if (!res?.json?.length) {

          PostCallWithErrorResponse(ApiConfig?.NO_RESPONSE_QUES, JSON.stringify({
            "sender_id": userData?.Username,
            "question_text": msg.replaceAll("@Vehicle Ai assistant", "").trim(),
            "domain_id": Number(selectedDomainId)
          }))

        }

        const data = res.json?.[0]?.custom?.data || "I don't have that info. Anything else I can help with?"
        const dataintent = res.json?.[0]?.custom?.intent
        getTestCasess(dataintent)
        setUploadedFiles([]);
        setReplyTo({});
        setmessage("");
        setMenstionedUsers([]);
        sendMessage(
          data,
          [],
          "",
          [],
          5149,
          true,
          ChatBotAiData.FirstName

        );



      })
      .catch(() => {
        setLoading(false);

      });
  };




  const getTestCasess = (data) => {
    const url = `${ApiConfig.CHATBOTSUCCES}?intent=${encodeURIComponent(data)}&domain_id=${selectedDomainId}`;

    simpleGetCallWithToken(url).then((res) => {
      console.log("How can I set the weekend days in the General Settings?", res);

      if (res?.success) {
        // Handle success

        res?.data?.forEach((i) => {

          sendMessage(
            i?.test_case_code_id + '\n \n' + i?.test_steps + i?.expected_results + '\n \n' + i?.test_case_description,
            [],
            "",
            [],
            5149,
            true,
            ChatBotAiData.FirstName

          );

        })

      } else {
        // Handle failure
      }
    });
  };






  // useEffect(() => {
  //   if (project?.subchannel?.length > 0) {
  //     setCurrentSChannel(project.subchannel[1]?.Team_Channel_Id);
  //   }
  // }, [project?.subchannel]);
  // //////////////////////////////////////////////////////////////////////////////{issue fix}
  const createSubChannelMember = () => {

    let body = JSON.stringify({
      type: "Project",
      schannel_id: currentSChannel, ///whern Add User in sub Chaneel  /get-projects-android/Team_Channel_Id
      // "channel_id":id,  //// sub chaneel Create User get-projects-android /channel_id
    });
    setSubchianlMemberList([])

    setLoading(true);
    if (activeChat.Team_Channel_Name == "General") {
      simpleGetCallWithErrorResponse(ApiConfig.SEARCH_ALL).then((res) => {

        if (res?.json?.success) {
          setSubchianlMemberList(res.json.data)
        }

      })
    } else {
      PostCallWithErrorResponse(ApiConfig.CREATE_SUB_CHANNEL_ADDMEMBER, body)
        .then((res) => {
          setLoading(false);
          if (res.json.status) {
            setSubchianlMemberList(res.json.data)

          } else

            notifyError(res.json.message);
        })
        .catch((err) => {
          setLoading(false);
          notifyError(err);
        });
    }
  };

  return {
    // local state + setters
    members, setMembers,
    addMembers, setAddMembers,
    addSubMembers, setAddSubMembers,
    newMessage, setNewMessage,
    files, setFiles,
    uploadedFiles, setUploadedFiles,
    SubchianlMemberList, setSubchianlMemberList,
    message, setmessage,
    membersAdded, setMembersAdded,
    menstionedUsers, setMenstionedUsers,
    selectedReaction, setselectedReaction,
    showAudioErr, setShowAudioErr,
    audioPreview, setAudioPreview,
    closeOutsideClick, setCloseOutSideClic,
    emogi, setEmogi,
    openVoiceReq, setOpenVoiceReq,
    ChatBotAiData, setChatBotAiData,
    reactions, setReactions,
    prevDate, setPrevDate,

    // refs
    fileUpload, toast, lastMsg, firstMsg, pindropdown, msgRef, inputRef,

    // context passthroughs (so JSX does not need its own useContext)
    sendMessage, activeChat, userData, socket, currentSChannel, setActiveChat,
    teamMembers, page, conversations, newMessages, userTyping,
    editMsg, setEditMsg, setNewMessages,
    replyTo, setReplyTo,
    noMorePages, paginationLoader, setPage, loading,
    suggetions, membersArray,
    setUserTyping, setLoading, setPaginationLoader,
    setConversations, setNoMorePages,
    setRecentChats, recentChats, pinnedChats, setPinnedChats,
    projects, setProjects, teams, setTeams,
    projectIdTast, permissions, SubChannelId, setmsgdelete, selectedDomainId,

    // derived
    user, last_seen,

    // handlers
    handleReactionShow, save, onSelect, onRemove, deletMessage,
    pinChat, unpinChat, removeReaction, addCreateTask, handleCopyUrl,
    chatbotapicall, getTestCasess, createSubChannelMember, joinRoom,
  };
};

export default useChatBox;
